import React, {useState} from 'react';
// import Logo from '../Logo/Dark/Full - Copy/1Asset 17@72x-8.png';
import { useAuth } from '../../AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box, Button, Toolbar, Tooltip, IconButton, useMediaQuery, TextField, Typography } from '@mui/material';
import {
  Search as SearchIcon,
  Clear as ClearIcon,
} from '@mui/icons-material';
import Logo1 from '../Logo/Dark/Icon - Copy/1Asset 15@72x-8.png';
import Logo from '../Logo/Dark/Full - Copy/1Asset 17@72x-8.png';





const API_URL = process.env.REACT_APP_API_URL;

function Header({page_name, onSearch}) {
  const theme = useTheme();
  // const { userId } = useAuth();
  const userId = 'f8b1c85b-90e2-4e24-8e41-4c2896990b10'
  
  const { role } = useAuth()
  const { logout } = useAuth();

  const [isSearchActive, setIsSearchActive] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const allowedPages = ['posted'];
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();

  const handleClear = () => setSearchQuery('');
  const handleLogout = () => {
    logout();
    navigate('/login');
  };


  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      // userId = 'f8b1c85b-90e2-4e24-8e41-4c2896990b18'
      fetch(`${API_URL}/get_search_results/?page_name=${page_name}&search_input=${searchQuery}&user_id=${userId}`)
        .then(res => res.json())
        .then(data => {
          onSearch(data);
          setSearchQuery('');
          setIsSearchActive(false);
        })
        .catch(console.error);
    }
  };
  
  
  return (
    <Box
            sx={{
              width: '100%',
              position: 'fixed',
              top: 0,
              left: 0,
              zIndex: 1100,
              bgcolor: '#000000',
              color: 'white',
              px: 2,
              // py: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              borderBottom: isMobile ? '1px solid #333' : 'none',
              // borderBottom: '1px solid #333',
            }}
          >
            
      {/* Logo Section */}
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Link to="/home" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                  <img src={isMobile ? Logo1 : Logo} alt="Logo" style={{ width: isMobile ? '40px' : '120px' }} />
                </Link>
              </Box>

      {allowedPages.includes(page_name) && !isMobile && (
                <Box
                  component="form"
                  onSubmit={handleSearchSubmit}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                    maxWidth: 600,
                    bgcolor: '#000000',
                    borderRadius: 2,
                    px: 1.5,
                    py: 0.5,
                    mx: 2,
                    flexGrow: 1,
                  }}
                >
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          {searchQuery && (
                            <Tooltip title="Clear">
                              <IconButton onClick={handleClear} size="small" sx={{ color: 'white' }}>
                                <ClearIcon />
                              </IconButton>
                            </Tooltip>
                          )}
                          <Tooltip title="Search">
                            <IconButton type="submit" size="small" sx={{ color: 'white' }}>
                              <SearchIcon />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      ),
                      sx: {
                        input: { color: 'white' },
                        backgroundColor: '#1c1c1c',
                        borderRadius: 2,
                        '& .MuiOutlinedInput-notchedOutline': { borderColor: '#444' },
                      },
                    }}
                  />
                </Box>
              )}

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {allowedPages.includes(page_name) && isMobile && (
            <Tooltip title="Search">
              <IconButton onClick={() => setIsSearchActive(true)} sx={{ color: 'white' }}>
                <SearchIcon />
              </IconButton>
            </Tooltip>
          )}
        </Box>

       

      <Box
        display="flex"
        flexDirection="row" // Keep buttons in a row
        alignItems="center"
      >
         <Tooltip title="Platform" placement="bottom">
                    <IconButton component={Link} to={`/`} color="inherit">
                      <Typography
                      component="h1"
                        sx={{
                          backgroundImage: "linear-gradient(45deg, #00bfff, #ff00ff)",
                          backgroundClip: "text",
                          color: "transparent",
                          letterSpacing: 4,
                          
                          fontSize: { xs: '0.7rem', sm: '1rem' },
                        }}
                      >
                        Vimitra
                      </Typography>
                      <Box
                        sx={{
                          ml: 1,
                          px: 0.5,
                          py: 0.1,
                          bgcolor: '#1E90FF',
                          borderRadius: '4px',
                          color: 'white',
                          fontSize: { xs: '0.55rem', sm: '0.7rem' },
                          fontWeight: 'bold',
                          textTransform: 'uppercase',
                        }}
                      >
                        Beta
                      </Box>
                    </IconButton>
                  </Tooltip>
        <Link
          to="/login"
          style={{
            textDecoration: 'none',
            marginLeft: '10px',
            marginRight: '10px' // Add gap between buttons
          }}
        >
          <Button
            variant="outlined"
            size="small"
            sx={{
              letterSpacing: 4,
              transition: 'transform 0.3s', // Smooth transition for scaling
              '&:hover': {
                transform: 'scale(1.1)', // Expand button on hover
              }
            }}
          >
            Login
          </Button>
        </Link>


      </Box>

      {/* Spacer for fixed header */}
           
      
            {/* Mobile Fullscreen Search */}
            {allowedPages.includes(page_name) && isMobile && isSearchActive && (
              <Box
                sx={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  bgcolor: 'rgba(0,0,0,0.95)',
                  zIndex: 1300,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  px: 2,
                }}
              >
                <TextField
                  autoFocus
                  fullWidth
                  variant="outlined"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && handleSearchSubmit(e)}
                  InputProps={{
                    endAdornment: (
                      <IconButton onClick={handleSearchSubmit} color="primary">
                        <SearchIcon />
                      </IconButton>
                    ),
                    sx: {
                      backgroundColor: 'white',
                      borderRadius: 2,
                    },
                  }}
                />
                <Button onClick={() => setIsSearchActive(false)} sx={{ mt: 2, color: 'white' }}>
                  Cancel
                </Button>
              </Box>
            )}
    </Box>


  );
}

export default Header;
